export default __webpack_public_path__ + "static/media/homeimg.ad3f2280.svg";